import { useState, useEffect } from "react";
import { EnergyPlant1SldApi } from "../../../../../../api/Api";
import { PASS_KEY, WEB_KEY } from "../../../../../../api/AxiosApi";

export default function Plant1Sld({SUB_PLANT}) {
    const [logData, setLogData] = useState(null);
    const [loading, setLoading] = useState(false); // Loading state

    const credentials = {
        LOGIN_ID: localStorage.getItem("LoginID"),
        LOC_CODE: localStorage.getItem("LCODE"),
        PASS_KEY:"xxxxxxxxxxx",
        WEB_KEY:"ABCXYZ",
        SUB_PLANT:SUB_PLANT
    };

    useEffect(() => {
        fetchLogData(); // Initial call

        const interval = setInterval(() => {
            fetchLogData();
        }, 40000); // 40 seconds

        return () => clearInterval(interval); // Cleanup on unmount
    }, []);

    const fetchLogData = async () => {
        setLoading(true); // Start loading
        try {
            const imageUrl = await EnergyPlant1SldApi(credentials);
            setLogData(imageUrl);
        } catch (error) {
            // console.error("Error fetching log data:", error);
            setLogData(null);
        } finally {
            setLoading(false); // Stop loading
        }
    };

    return (
        <div className="row">
            {loading ? (
                <p>Loading...</p> // Show loading indicator
            ) : logData ? (
                <div className="col-md-12">
                    <img
                        src={logData}
                        alt="SLD Image"
                        style={{ width: "100%", height: "auto", objectFit: "cover" }}
                    />
                </div>
            ) : (
                <p>No image available</p>
            )}
        </div>
    );
}